import React from "react";
import { ToastContainer } from "react-toastify";
import ModalsComponentProps from "./ModalsComponentProps";
import 'react-toastify/dist/ReactToastify.css';
import './ModalsStyles.css';
import ModalCustomComponent from "./custom/modal_custom.component";
import DeleteModalComponent from "./delete/DeleteModalComponent";
import { isDarkTheme } from "../../../utils/dark_theme";

const ModalsComponent: React.FC<ModalsComponentProps> = ({ children }) => {

    return <div className="modals_component">
        <ModalCustomComponent />
        <DeleteModalComponent />
        <ToastContainer position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            toastStyle={{ backgroundColor: "var(--color-bg)"}}
            progressStyle={{ backgroundColor: "var(--color-yellow)" }}
            theme="dark" />
        {/* // theme={isDarkTheme() ? "dark": "light"} /> */}
        {children}
    </div>
}


export default ModalsComponent;